export default __webpack_public_path__ + "static/media/LOGO2.fc9236bd.png";